import ClientAPI from "../../api/client.js";
import router from "../../router";

export const client = {
    namespaced: true,
    state: {
        clients: {},
        client: {
            examinations: []
        }
    },
    actions: {
        CLIENTS: async ({ state, commit }) =>
            ClientAPI.refresh(state.lastUpdate)
                .then(({ data: { data: clients, lastUpdate: lastUpdate } }) => {
                    commit("LAST_UPDATE", lastUpdate)
                    commit("CLIENTS", clients)
                })
                .catch(() => {
                    commit("CLIENTS", {});
                }),

        CLIENT: async ({ commit }, data) =>
            ClientAPI.getClient(data.id)
                .then(function (response) {
                    commit("CLIENT", response.data);
                })
                .catch(function () {
                    commit("CLIENT", {});
                }),
        RESET: ({ commit }) => commit("CLIENT", {}),
        SAVE: ({ commit }, client) => ClientAPI.save(client).then(({ data: c }) => client.id ? null : router.push('/clients/' + c.id)),
        DELETE: ({ commit, state }) => {
            commit("REMOVE", state.client.id);
            ClientAPI.deleteClient(state.client.id);
        }
    },

    mutations: {
        LAST_UPDATE: (state, lastUpdate) => (state.lastUpdate = lastUpdate),
        CLIENTS: (state, clients) =>
            (state.clients = Object.assign(state.clients, clients)),
        CLIENT: (state, client) => {
            state.client = client;
            if (client.id) {
                state.clients[client.id] = client;
            }
        },
        REMOVE: (state, id) => {
            delete state.clients[id];
        }
    }
};
